import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const TwoColumns = t0 => {
  const $ = _c(7);
  const {
    column1,
    column2
  } = t0;
  let t1;
  if ($[0] !== column1) {
    t1 = <div className="[grid-area:TwoColumns__column1]">{column1}</div>;
    $[0] = column1;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== column2) {
    t2 = <div className="[grid-area:TwoColumns__column2]">{column2}</div>;
    $[2] = column2;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="grid grid-cols-[1fr_1fr] grid-rows-[auto] gap-6 [grid-template-areas:'TwoColumns__column1_TwoColumns__column2']">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
TwoColumns.propTypes = {
  column1: PropTypes.node,
  column2: PropTypes.node
};
export default TwoColumns;